module.exports = __webpack_public_path__ + "img/invoice.357dc0f8.png";